import React from 'react';
import styles from './simple-layout.scss';

type Props = {
  children?: React.ReactNode;
};

const FullHeightLayout = ({ children }: Props) => (
  <div className={styles.container}>{children}</div>
);

export default FullHeightLayout;
